import { Dialog } from '@/components/UI/Dialog'
import { MYNAVI_PRIMARY } from '../Color'
import { MyNaviTypography } from '../MyNaviUI/MyNaviTypography'

export type MyNaviDialogButton = {
  label: string
  variant: 'blue' | 'white'
  onClick: () => void
}

export type MyNaviDialogProps = {
  isOpen: boolean
  onClose: () => void
  /** 青字で中央表示されるメッセージ */
  message: string
  /** メッセージの位置調整 */
  messageTextAlign?: 'text-left' | 'text-center'
  buttons: MyNaviDialogButton[]
}

export const MyNaviDialog = ({
  isOpen,
  onClose,
  message,
  buttons,
  messageTextAlign = 'text-center',
}: MyNaviDialogProps) => {
  return (
    <Dialog selectorState={isOpen} closeFunc={onClose} showCloseButton>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '16px',
          padding: '8px 8px 16px',
        }}
      >
        <MyNaviTypography
          variant="dialog-title"
          as="p"
          className={`${messageTextAlign} leading-[1.6] m-0 whitespace-pre-wrap`}
          style={{ color: MYNAVI_PRIMARY }}
        >
          {message}
        </MyNaviTypography>
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '8px' }}>
          {buttons.map((btn) => (
            <button
              key={btn.label}
              type="button"
              onClick={() => {
                btn.onClick()
                onClose()
              }}
              style={{
                width: '100%',
                height: '48px',
                borderRadius: '8px',
                border: btn.variant === 'white' ? `1px solid ${MYNAVI_PRIMARY}` : 'none',
                backgroundColor: btn.variant === 'blue' ? MYNAVI_PRIMARY : 'white',
                color: btn.variant === 'blue' ? 'white' : MYNAVI_PRIMARY,
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: 700,
                fontFamily: "'Noto Sans JP', sans-serif",
              }}
            >
              {btn.label}
            </button>
          ))}
        </div>
      </div>
    </Dialog>
  )
}
